import * as XLSX from "xlsx";



const getLeafKeys = (data) => {
  const keys = new Set();

  if (!Array.isArray(data)) {
    console.warn("Expected array but got:", typeof data);
    return [];
  }

  const extract = (item) => {
    if (Array.isArray(item)) {
      item.forEach(subItem => extract(subItem));
    } else if (item !== null && typeof item === 'object') {
      Object.entries(item).forEach(([key, value]) => {
        if (key === "_id") return; // skip _id keys

        keys.add(key); // add parent key

        // If value is object or array, DO NOT extract deeper (skip child keys)
        // So do nothing more here
      });
    }
  };

  data.forEach(entry => extract(entry));
  return Array.from(keys);
};


export const buildExcelSchema = (data, modelName) => {
  const leafKeys = getLeafKeys(data);

  const formatted = leafKeys.map((key, index) => ({
    originalName: key,
    newName: key,
    order: index + 1,
    isShow: "YES"
  }));

  const worksheet = XLSX.utils.json_to_sheet(formatted);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Schema");

  XLSX.writeFile(workbook, `${modelName?.label || 'schema'}.xlsx`);
};
